import React from 'react';
import WidgetList from '../../editor/components/WidgetList';
import { compose, branch, renderNothing, renderComponent } from 'recompose';

import { withPlayerWidgets } from '../hoc/widgets';

const NoTournamnet = () => <div style={{ textAlign: 'center', padding: 15 }}>Please select tournamnet above</div>;
const NoTeam = () => <div style={{ textAlign: 'center', padding: 15 }}>Please select team above</div>;

const PlayerOverview = compose(
    branch(({ tournamentId }) => !tournamentId, renderComponent(NoTournamnet)),
    branch(({ teamId }) => !teamId, renderComponent(NoTeam)),
    branch(({ playerId }) => !playerId, renderNothing),
)(withPlayerWidgets(WidgetList));

export default PlayerOverview;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/containers/PlayerOverview.js
 **/